/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TierChangeNotificationActionData
 */
export interface TierChangeNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof TierChangeNotificationActionData
     */
    newTier: string;
    /**
     * 
     * @type {string}
     * @memberof TierChangeNotificationActionData
     */
    currentValue: string;
    /**
     * 
     * @type {number}
     * @memberof TierChangeNotificationActionData
     */
    newTierValue: number;
}

/**
 * Check if a given object implements the TierChangeNotificationActionData interface.
 */
export function instanceOfTierChangeNotificationActionData(value: object): value is TierChangeNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "newTier" in value && value["newTier"] !== undefined;
    isInstance = isInstance && "currentValue" in value && value["currentValue"] !== undefined;
    isInstance = isInstance && "newTierValue" in value && value["newTierValue"] !== undefined;

    return isInstance;
}

export function TierChangeNotificationActionDataFromJSON(json: any): TierChangeNotificationActionData {
    return TierChangeNotificationActionDataFromJSONTyped(json, false);
}

export function TierChangeNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TierChangeNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'newTier': json['new_tier'],
        'currentValue': json['current_value'],
        'newTierValue': json['new_tier_value'],
    };
}

export function TierChangeNotificationActionDataToJSON(value?: TierChangeNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_tier': value.newTier,
        'current_value': value.currentValue,
        'new_tier_value': value.newTierValue,
    };
}

